import axios from "axios";
import {format, parseISO} from "date-fns";
import ru from "date-fns/locale/ru";

export const instance = axios.create({
  timeout: 10000
});

export const getMasterClassSystem = id => {
  const response = instance({
    method: "get",
    url: `/work/api/master-class/${id}`
  });
  return response;
};

export const getMasterClass = id => {
  const response = instance({
    method: "get",
    url: `/work/api/master-class/${id}/main`
  });
  return response;
};

export const getMasterClassCard = id => {
  const response = instance({
    method: "get",
    url: `/work/api/master-class/${id}/card`
  });
  return response;
};

export const createMasterClass = data => {
  const response = instance({
    method: "post",
    url: `/work/api/master-class/`,
    data
  });
  return response;
};

export const updateMasterClass = (id, main) => {
  const data = { main: main };

  const response = instance({
    method: "put",
    url: `/work/api/master-class/${id}`,
    data
  });
  return response;
};

export const deleteMasterClass = id => {
  const response = instance({
    method: "delete",
    url: `/work/api/master-class/${id}`
  });
  return response;
};

export const deleteLogo = (id) => {
  const response = instance({
    method: "delete",
    url: `/work/api/master-class/${id}/logo`,
  });
  return response;
};

export const updateLogo = (id, file) => {
  const data = new FormData();
  data.set('file', file);

  const response = instance({
    method: "post",
    url: `/work/api/master-class/${id}/logo`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data
  });
  return response;
};

export const updateDocument = (id, file) => {
  const data = new FormData();
  data.set('file', file);

  const response = instance({
    method: "post",
    url: `/work/api/master-class/${id}/document`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data
  });
  return response;
};

export const deleteDocument = (id) => {
  const response = instance({
    method: "delete",
    url: `/work/api/master-class/${id}/document`,
  });
  return response;
};

export const changeMasterClassState = (masterClassId, actionName) => {
  const data = {
    type : actionName,
    id: masterClassId
  };

  const response = instance({
    method: "post",
    url: `/work/api/master-class/rpc`,
    headers: {
      "Content-Type": "application/json",
    },
    data
  });
  return response;
}

export const getMasterClassStudents = id => {
  const response = instance({
    method: "get",
    url: `/work/api/master-class/${id}/students`
  });
  return response;
};

export const createNewStudent = (id, main) => {
  const data = {
    type : "create-student",
    masterClass : id,
    lastName : main.lastName,
    firstName : main.firstName,
    middleName : main.middleName,
    sex : main.sex,
    birthday : main.birthday,
    snils : main.snils,
    region : main.region,
    municipal : main.municipal,
    phone : main.phone,
    email : main.email,
    register : main.register
  };

  const response = instance({
    method: "post",
    url: `/work/api/master-class/rpc`,
    headers: {
      "Content-Type": "application/json",
    },
    data
  });
  return response;
}

export const addStudent = (id, studentId) => {
  const data = {
    type : "add-student",
    masterClass : id,
    student : studentId
  };

  const response = instance({
    method: "post",
    url: `/work/api/master-class/rpc`,
    headers: {
      "Content-Type": "application/json",
    },
    data
  });
  return response;
}

export const deleteStudent = (id, studentId) => {
  const data = {
    type : "remove-student",
    masterClass : id,
    student : studentId
  };

  const response = instance({
    method: "post",
    url: `/work/api/master-class/rpc`,
    headers: {
      "Content-Type": "application/json",
    },
    data
  });
  return response;
}

export const getMasterClassListByProgram = id => {
  const response = instance({
    method: "get",
    url: `/work/api/master-class/program/${id}`
  });
  return response;
};

export default {
  getMasterClassSystem,
  getMasterClass,
  getMasterClassCard,
  createMasterClass,
  updateMasterClass,
  deleteMasterClass,
  updateLogo,
  updateDocument,
  deleteLogo,
  deleteDocument,
  changeMasterClassState,
  getMasterClassStudents,
  createNewStudent,
  addStudent,
  deleteStudent,
  getMasterClassListByProgram
}
